(function () {
  var companyId = window.klaviyoCompanyId;
  if (!companyId) return;

  // Tags the URL so Klaviyo's own "Don't show on certain URLs" targeting can
  // exclude the legacy auto-display form here without touching its config
  // (which is shared with the A theme and must stay untouched there).
  function ensureVariantMarker() {
    try {
      var url = new URL(window.location.href);
      if (url.searchParams.get('kl_b') === '1') return;
      url.searchParams.set('kl_b', '1');
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (e) {
      // URL/history APIs unavailable - not fatal, just skip tagging.
    }
  }

  ensureVariantMarker();

  var loaded = false;

  function marketingConsentGranted() {
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.marketingAllowed === 'function') {
      return window.Shopify.customerPrivacy.marketingAllowed();
    }
    // MPCF (snippets/cookie-settings.liquid) sets/clears this cookie in lockstep
    // with marketing consent, so it's a safe fallback before the Privacy API is ready.
    return document.cookie.indexOf('__kla_off=true') === -1;
  }

  function loadOnsiteScript() {
    if (loaded || !marketingConsentGranted()) return;
    loaded = true;

    // Created via document.createElement so MPCF's own script-blocking guard
    // (installed when consent is denied) still applies as a second layer of defense.
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://static.klaviyo.com/onsite/js/' + companyId + '/klaviyo.js?company_id=' + companyId;
    document.head.appendChild(script);
  }

  loadOnsiteScript();

  // MPCF dispatches these when consent changes without a page reload.
  document.addEventListener('truyoCookieSettingsUpdateEvent', loadOnsiteScript);
  document.addEventListener('visitorConsentCollected', loadOnsiteScript);

  // Shared with klaviyo-desktop-auto-open.js so both scripts gate on the
  // same consent signal instead of duplicating the check.
  window.klaviyoMarketingConsentGranted = marketingConsentGranted;
})();
